import React from 'react';
import { GemIcon } from 'lucide-react';
export function Guarantee() {
  return <section className="bg-cream-deep py-12 sm:py-20" aria-labelledby="garantia" data-id="element-37" data-mp="1o3ncvzyfwkwu">
      <div className="mx-auto max-w-3xl px-4 sm:px-6" data-id="element-38" data-mp="1o5zsw7kn0l79">
        <div className="rounded-[1.75rem] bg-cream p-6 ring-1 ring-champagne/40 sm:rounded-[2rem] sm:p-12" data-id="element-39" data-mp="222db5iwzwqms">
          <GemIcon aria-hidden="true" className="h-7 w-7 text-champagne sm:h-8 sm:w-8" data-id="element-40" data-mp="1x5muouha3t0u" />
          <h2 id="garantia" className="mt-5 font-display text-[1.6rem] font-semibold leading-tight text-ink sm:mt-6 sm:text-4xl" data-id="element-41" data-mp="19fsj0g8p4ai6">
            Garantía Total &lsquo;Diamond Shield&rsquo; de 7 días
          </h2>
          <p className="mt-5 text-[15px] leading-relaxed text-ink/75 sm:mt-6 sm:text-lg" data-id="element-42" data-mp="1j5c13jol40bz">
            Entrá. Estudiá el contenido. Aplicá las técnicas con clientas reales. Si en 7 días no ves
            el potencial de transformar tu vida con este método, te devuelvo cada peso. Sin
            formularios, sin excusas, sin demoras.
          </p>
          <p className="mt-4 font-display text-lg text-ink sm:mt-5 sm:text-2xl" data-id="element-43" data-mp="ozjfev315uuf">
            El riesgo es 100% mío. Vos no arriesgás absolutamente nada.
          </p>
        </div>
      </div>
    </section>;
}